/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import { Stack } from "@mui/material";
import Icon, { IconProps } from "@/src/components/Icon/Icon.tsx";
import IconFamilyLaw from "@/src/assets/iconsRedesign2026/familyLaw/toggleable/IconFamilyLaw.tsx";
import IconTrafficLaw from "@/src/assets/iconsRedesign2026/traffic/toggleable/IconTrafficLaw.tsx";
import IconEmploymentLaw from "@/src/assets/iconsRedesign2026/common/toggleable/IconEmploymentLaw.tsx";
import IconRentalLaw from "@/src/assets/iconsRedesign2026/contract/toggleable/IconRentalLaw.tsx";
import IconContractLaw from "@/src/assets/iconsRedesign2026/contract/toggleable/IconContractLaw.tsx";
import IconCivilServiceLaw from "@/src/assets/iconsRedesign2026/administrativeLaw/toggleable/IconCivilServiceLaw.tsx";
import IconCivilLaw from "@/src/assets/iconsRedesign2026/civilLaw/toggleable/IconCivilLaw.tsx";
import IconCode from "@/src/assets/iconsRedesign2026/generic/toggleable/IconCode.tsx";
import IconFolderCheck from "@/src/assets/iconsRedesign2026/generic/toggleable/IconFolderCheck.tsx";

export default function IconStyleguide() {
  return (
    <>
      <StyleguideView title={"Inactive"}>
          <IconExamples />
      </StyleguideView>
      <StyleguideView title={"Active"} dark>
          <IconExamples active />
      </StyleguideView>
      <StyleguideView title={"Bordered"}>
          <IconExamples variant={"bordered"} />
      </StyleguideView>
      <StyleguideView title={"Bordered Active"}>
          <IconExamples variant={"bordered"} active />
      </StyleguideView>
    </>
  );
}

function IconExamples(props: Omit<IconProps, "icon">) {
  return (
    <Stack direction={"row"} spacing={"1.5rem"} useFlexGap sx={{ flexWrap: "wrap" }}>
      <Icon icon={IconFamilyLaw} {...props} />
      <Icon icon={IconTrafficLaw} {...props} />
      <Icon icon={IconRentalLaw} {...props} />
      <Icon icon={IconEmploymentLaw} {...props} />
      <Icon icon={IconContractLaw} {...props} />
      <Icon icon={IconCivilServiceLaw} {...props} />
      <Icon icon={IconCivilLaw} {...props} />
      <Icon icon={IconCode} {...props} />
      <Icon icon={IconFolderCheck} {...props} />
    </Stack>
  );
}
